import { useOnboardingStepViewed } from '@/hooks/use-analytics'
import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Mail } from 'lucide-react'

export const Route = createFileRoute('/onboarding/verify-email-sent')({
  component: VerifyEmailSentPage,
  validateSearch: (search: Record<string, unknown>) => ({
    email: (search['email'] as string) || '', // eslint-disable-line dot-notation
  }),
})

function VerifyEmailSentPage() {
  useOnboardingStepViewed('verify_email_sent')
  const { email } = Route.useSearch()

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Mail className="h-6 w-6 text-primary" />
          </div>
          <CardTitle className="text-2xl">Your report is almost ready</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            We sent a verification link to
            {' '}
            <span className="font-medium text-foreground">{email}</span>
            . Click the link to unlock
            your personalized market research report.
          </p>
          <p className="text-sm text-muted-foreground">
            The link expires in 7 days. Check your spam folder if you don't see it.
          </p>
          <p className="text-sm text-muted-foreground">
            Didn't receive it?
            {' '}
            <a href="/onboarding" className="text-primary underline underline-offset-4 hover:text-primary/80">
              Try again
            </a>
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
